import mitt from 'mitt'

export default {
  install: (app) => {

    const emitter = mitt()

    const events = {
      fire(name, data = null) {
        emitter.emit(name, data)
      },

      emit(name, data = null) {
        emitter.emit(name, data)
      },

      $emit(name, data = null) {
        emitter.emit(name, data)
      },

      listen(name, cb) {
        emitter.on(name, cb)
      },

      on(name, cb) {
        emitter.on(name, cb)
      },

      $on(name, cb) {
        emitter.on(name, cb)
      },

      off(name, cb) {
        emitter.off(name, cb)
      },

      $off(name, cb) {
        emitter.off(name, cb)
      },

      remove(name, cb) {
        emitter.off(name, cb)
      },
    }

    app.config.globalProperties.$events = events
  },

}
